<template>
  <b-modal
    id="batch-modal"
    hide-header
    hide-footer
    centered size="sm"
    @hidden="closeModal"
  >
    <div class="header">
      <div class="modal-title">Cadastro de Lote</div>
      <span class="icon-box"><Close class="close-svg stroke" @click="closeModal"  /></span>
    </div>
    <div class="body">
      <div class="row md-content p-3">
        <div class="col-12">
            <b-form-group 
              :invalid-feedback="errors.batch ? 'Campo obrigatório' : ''"
              :invalid="errors.batch"
            >
              <label for="batch">Código</label>
              <b-form-input
                  id="batch"
                  trim
                  autocomplete="off"
                  placeholder="Descrever"
                  v-model="form.batch"
                  :class="{'is-invalid': errors.batch}"
              />
            </b-form-group>
        </div>
        <div class="col-12">
            <b-form-group id="field_manufacturing_date">
                <label for="manufacturing_date">
                    Data de fabricação
                    <span class="help">(opcional)</span>
                </label>
                <date-picker
                    id="manufacturing_date"
                    class="full"
                    v-model="form.manufacturing_date"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/AAAA"
                    :clearable="true"
                    :lang="langDatePicker"
                ></date-picker>
            </b-form-group>
        </div>
        <div class="col-12">
            <b-form-group 
              :invalid-feedback="errors.expiration_date ? 'Campo obrigatório' : ''"
              :invalid="errors.expiration_date"
            >
                <label for="date">
                    Data de validade
                </label>
                <date-picker
                    id="expiration_date"
                    class="full expiration-picker"
                    v-model="form.expiration_date"
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/AAAA"
                    :clearable="true"
                    :lang="langDatePicker"
                    :class="{'is-invalid': errors.expiration_date}"
                    :append-to-body="false"
                ></date-picker>
            </b-form-group>
        </div>
      </div>

      <div class="md-button">
        <b-button
          class="wh-button"
          variant="primary"
          size="lg"
          @click="createBatch()"
        >
            Salvar
        </b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { getCurrentClinic } from '../../utils/localStorageManager'

export default {
  name: 'BatchModal',
  components: {
    Close: () => import('@/assets/icons/close.svg'),
  },
  props: {
    batch: Object
  },
  data() {
    const clinic = getCurrentClinic()
    return {
      validated: false,
      form: {
        ...this.batch,
        clinic_id: clinic.id,
      },
      errors: {},
      langDatePicker: {
        formatLocale: {
          weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
        }
      },
    }
  },
  methods: {
    createBatch() {
      if (!this.isValidForm()) return;
      this.$emit('save-batch', this.form);
      this.$bvModal.hide('batch-modal');
    },
    clearForm() {
      this.form = {
      }
      this.errors = {};
    },
    isValidForm() {
      let isValid = true;
      const errors = {};
      
      if (!this.form.batch) {
        isValid = false;
        errors.batch = true;
      };

      if (!this.form.expiration_date) {
        isValid = false;
        errors.expiration_date = true;
      };

      this.errors = errors;
      return isValid;
    },
    closeModal() {
      this.clearForm();
      this.$bvModal.hide('batch-modal');
      this.$emit('onHide', this.form);
    },
  },
  watch: {
    batch: function(newValue) {
      if (newValue) {
        this.form = { ...newValue };
      } else {
        this.clearForm();
      }
    },
  }
}
</script>
<style lang="scss">
.expiration-picker {
  .mx-calendar-panel-year {
    .mx-btn-icon-double-right {
      display: block;
    }
  }
}

#batch-modal {
  .modal-content {
    .modal-body {
      padding: 0 !important;

      .header {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 24px;
        border-bottom: 1px solid var(--neutral-200);

        .close-svg {
            height: 24px;
            width: 24px;
            fill: var(--neutral-500);
        }
      }
    }
  }
  .modal-title {
    font-size: 18px;
    color: var(--dark-blue);
    font-weight: 600;
  }
  .icon {
    width: 25px;
  }
  .md-content {
    padding: 30px 20px 10px 20px;
  }
  .md-button {
    text-align: right;
    margin-right: 20px;
    margin-bottom: 10px;
  }
}
</style>
